module.exports = __webpack_public_path__ + "static/media/3DPPA15.2f56f8c7.jpg";